import request from '@/utils/request'

export interface IStoreVersion {
  id?: string
  version?: number
  isMajor?: boolean
  storeUrl?: string
  os?: number // 0=UI, 1=iOS, 2=Android
  isLatest?: boolean
}

export const listStoreVersions = () =>
  request({
    url: '/storeVersion/list',
    method: 'get'
  })

export const updateStoreVersion = (id: string, data: Partial<IStoreVersion>) =>
  request({
    url: `/storeVersion/${id}`,
    method: 'put',
    data
  })
